export const locale = {
    'TRANSPORTUNIT': {
      'TITLE': 'Экипажи',
      'NOTRIP': 'У данного экипажа нет принятого заказа.'
    },
};
